module.exports = __webpack_public_path__ + "static/linguamillMobile@2x-8c40d737d3b6b074b941532c2fe4e705.jpg";